<template>
  <div class="bg">
    <group>
      <div class="infoLine">
        <div class="infoTitle avatar">头像</div>
        <div class="infoAvatar">
          <img v-if="params.avatar" :src="params.avatar" />
          <img v-else src="../../assets/avatar.png" />
          <input
            class="uploadInput"
            type="file"
            ref="file"
            @change="uploadAvatar"
          />
          <div class="uploadLoading" v-if="uploadLoading">
            <img src="../../assets/loading.gif" />
          </div>
        </div>
      </div>
    </group>
    <group>
      <x-input
        title="名称"
        text-align="right"
        placeholder="请输入名称"
        v-model="params.name"
        placeholder-align="right"
      ></x-input>
      <!--      <s-address-->
      <!--        ref="address"-->
      <!--        title="联系地址"-->
      <!--        v-model="params.addrCode"-->
      <!--        placeholder="请选择地址"-->
      <!--      ></s-address>-->
      <x-input
        title="详细地址"
        text-align="right"
        placeholder="请输入详细地址"
        v-model="params.addrDetail"
        placeholder-align="right"
      ></x-input>
    </group>
    <div class="saveButton" @click="saveUser">保存</div>
  </div>
</template>

<script>
// import SAddress from "@/components/Address";
import { modifyClient } from "@/api/client";
import { pick } from "@/utils/lodash";
import { mapActions } from "vuex";
import { uploadFile } from "@/api/file";
import { compress } from "@/components/Upload/compressor";
import { validateIdCard } from "@/utils/validate-util";

export default {
  name: "myInfoChange",
  // components: { SAddress },
  data() {
    return {
      params: {
        active: "",
        avatar: "",
        name: "",
        phone: "",
        street: "",
        address: []
      },
      uploadLoading: false,
      loadingImg: false,
      saveSuccess: false,
      nameDisabled: true
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    if (this.userInfo) {
      const {
        avatar,
        name,
        sex,
        provinceCode,
        idCard,
        cityCode,
        townCode,
        street
      } = this.userInfo;
      let address = [];
      if (provinceCode && cityCode && townCode) {
        address = [provinceCode, cityCode, townCode];
      }
      this.params = {
        ...this.userInfo,
        avatar,
        name,
        sex,
        address,
        street,
        idCard
      };
      if (this.params.name) {
        this.nameDisabled = true;
      } else {
        this.nameDisabled = false;
      }
    }
  },
  methods: {
    goUserFrame() {
      if (this.userInfo.frameRes == null) {
        this.$router.push("/user/templateDetail");
      } else {
        this.$router.push("/user/frameShow");
      }
    },
    ...mapActions(["fetchUserInfo"]),
    onConfirm() {},
    getAddress(e) {
      this.params.address = e;
    },
    uploadAvatar(e) {
      compress(e.target.files[0]).then(result => {
        this.uploadLoading = true;
        uploadFile("/avatar", result.file)
          .then(res => {
            this.params.avatar = res.path;
          })
          .catch(e => {
            this.$showError(e);
          })
          .finally(() => {
            this.uploadLoading = false;
          });
      });
    },
    saveUser() {
      let idCard = this.params.idCard || "";
      idCard = idCard.trim();
      if (!validateIdCard(idCard)) {
        this.$showError("身份证格式错误", "warn");
        return;
      }

      const rules = {
        name: "required",
        idCard: "required",
        sex: "required",
        address: "required"
      };

      const attrs = {
        name: "姓名",
        idCard: "身份证",
        sex: "性别",
        address: "地址"
      };

      this.$validate(this.params, rules, attrs)
        .then(() => {
          this.$vux.loading.show({
            transition: "",
            text: "提交中"
          });

          const params = pick(this.params, ["name", "sex", "street", "avatar"]);
          const [provinceCode, cityCode, townCode] = this.params.address;
          const [
            provinceName,
            cityName,
            townName
          ] = this.$refs.address.getAddressName().split(" ");
          // 提交三要素认证
          modifyClient({
            ...params,
            idCard,
            provinceCode,
            cityCode,
            townCode,
            provinceName,
            cityName,
            townName
          })
            .then(() => {
              this.$vux.loading.hide();
              this.$showError("更新成功");
              this.fetchUserInfo();
              // 跳转到客户详情页面
            })
            .catch(error => {
              this.$showError(error, "warn");
              this.$vux.loading.hide();
            });
        })
        .catch(error => {
          this.$showError(error, "warn");
        });
    }
  }
};
</script>

<style scoped>
.bg {
  font-size: 14px;
  overflow: hidden;
  color: #474747;
}
.imgBox img {
  width: 100%;
  height: 100%;
  display: block;
}
.oilText input {
  width: 100%;
  text-align: right;
  border: none;
  height: 80px;
  line-height: 80px;
}
.infoBox {
  overflow: hidden;
}
.infoLine {
  overflow: hidden;
  padding: 30px;
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
}
.infoTitle {
  width: 140px;
  font-size: 14px;
  line-height: 14px;
  color: #474747;
}
.avatar {
  line-height: 90px;
  display: block;
  float: left;
}
.infoAvatar {
  width: 86px;
  height: 86px;
  border-radius: 46px;
  border: 1px solid #eaeaea;
  float: right;
  overflow: hidden;
  position: relative;
}
.infoAvatar img {
  width: 100%;
  height: 100%;
}
.infoText input {
  line-height: 28px;
  width: 100%;
  text-align: right;
}
.uploadInput {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.uploadLoading {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.uploadLoading img {
  width: 32px !important;
  height: 32px !important;
  margin: 26px;
}
.saveButton {
  margin: 50px 30px;
  background: #007bec;
  height: 86px;
  line-height: 86px;
  text-align: center;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  letter-spacing: 10px;
}
.success {
  margin: 0 auto;
  text-align: center;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  color: red;
}
.loadingImg {
  width: 32px;
  height: 32px;
  line-height: 86px;
}
</style>
